//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "@nuskin/ns-core-styles/src/dist/main.css";

import { NsIcon } from "@nuskin/design-components";

export default {
  name: "NsInformationButton",
  components: {
    NsIcon
  },
  props: {
    imageSrc: {
      type: String,
      default: ""
    },
    imageAlt: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    url: {
      type: String,
      default: ""
    },
    opensNewTab: Boolean
  },
  computed: {
    show() {
      return this.showImage || !!this.title || !!this.description;
    },
    showImage() {
      return !!this.imageSrc && !this.isMobile;
    },
    altText() {
      return this.imageAlt;
    },
    isMobile() {
      return this.$mq === "mobile" || this.$mq === "phablet";
    }
  },
  methods: {
    handleClicked() {
      window.open(this.url, this.opensNewTab ? "_blank" : "_top");
    }
  }
};
